import { Banner } from "../../../services/common";

const BannerWithoutLink = ({banner}) => (
  <Banner src={`/images/banners/${banner?.primaryImage}`} />
);

export default BannerWithoutLink;